<template>
  <div class="main-body">
    <div class="header">
      用药计划
    </div>
    <div class="out">

      <div class="search2">

        <div style="float:right">

          <el-select v-model="institutionCode" placeholder="请选择机构">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-date-picker size="mini"
                          ref="picker"
                          v-model="datetimerangeValue"
                          type="daterange"
                          :clearable='false'
                          value-format="yyyy-MM-dd"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          style="width:230px;margin-left:10px">
          </el-date-picker>

          <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th"
                border>

        <el-table-column type="expand" v-if="tableData.length">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="早晨用药：" v-if="props.row.medicationSchedulingMorningDTO">

                <!--                <el-tag v-for="(value,i) in props.row.medicationSchedulingMorningDTO.medicationSchedulingMorningItemList" :key="i"-->
                <!--                        style="margin-right: 5px;">{{value.medicationGroupName}}</el-tag>-->


                <el-popover v-for="(value,i) in props.row.medicationSchedulingMorningDTO.listMedicationSchedulingMorningItemDTO" :key="i"
                            placement="right"
                            width="160"
                            title="药品" style="margin-right: 5px;"
                            trigger="hover">

                  <div v-for="(value2,i2) in value.listMedicationItem" :key="i2">
                    <span>{{value2.name}}</span>
                  </div>

                  <el-tag type="success" slot="reference">{{value.medicationGroupName}}</el-tag>

                </el-popover>


              </el-form-item>
              <el-form-item label="中午用药：" v-if="props.row.medicationSchedulingNoonDTO">

                <!--                <el-tag v-for="(value,i) in props.row.medicationSchedulingNoonDTO.medicationSchedulingNoonItemList" :key="i"-->
                <!--                        style="margin-right: 5px;" >{{value.medicationGroupName}}</el-tag>-->

                <el-popover v-for="(value,i) in props.row.medicationSchedulingNoonDTO.listMedicationSchedulingNoonItemDTO" :key="i"
                            placement="right"
                            width="160"
                            title="药品" style="margin-right: 5px;"
                            trigger="hover">

                  <div v-for="(value2,i2) in value.listMedicationItem" :key="i2">
                    <span>{{value2.name}}</span>
                  </div>

                  <el-tag type="success" slot="reference">{{value.medicationGroupName}}</el-tag>

                </el-popover>


              </el-form-item>
              <el-form-item label="晚上用药：" v-if="props.row.medicationSchedulingNightDTO">

                <!--                <el-tag v-for="(value,i) in props.row.medicationSchedulingNightDTO.medicationSchedulingNightItemList" :key="i"-->
                <!--                        style="margin-right: 5px;" >{{value.medicationGroupName}}</el-tag>-->


                <el-popover v-for="(value,i) in props.row.medicationSchedulingNightDTO.listMedicationSchedulingNightItemDTO" :key="i"
                            placement="right"
                            width="160"
                            title="药品" style="margin-right: 5px;"
                            trigger="hover">

                  <div v-for="(value2,i2) in value.listMedicationItem" :key="i2">
                    <span>{{value2.name}}</span>
                  </div>

                  <el-tag type="success" slot="reference">{{value.medicationGroupName}}</el-tag>

                </el-popover>

              </el-form-item>
            </el-form>
          </template>
        </el-table-column>

        <el-table-column prop="elderlyName" label="老人姓名"></el-table-column>

        <el-table-column prop="time" :formatter="getTime" label="用药日期"></el-table-column>
        <el-table-column prop="day" label="星期"></el-table-column>

        <el-table-column prop="Status" :formatter="statusTitle" label="状态"></el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>

  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Page",
  data(){
    return{
      loading:false,

      datetimerangeValue:'',

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      arr_ins:[],
      institutionCode: '',

    }
  },
  components:{

  },
  created(){
    this.init();

    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{
    init(){

      const start= new Date();
      const end=new Date(start.getTime() + 1000 * 60 * 60 * 24 * 30);
      this.datetimerangeValue=[start, end];

      this.getIns();

    },

    getTime(row){
      return timefilters(row.time).slice(0,10)
    },


    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },

    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"MedicationScheduling/GovPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          elderlyCode:'',
          institutionCode:this.institutionCode,
          startTime:this.datetimerangeValue[0],
          endTime:this.datetimerangeValue[1],
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {

        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    formatTime:function (row, column, cellValue) {
      return timefilters(cellValue);
    },

    statusTitle(row){
      if(row.status == 0){
        return "正常";
      }
      if(row.status == 1){
        return "禁用";
      }
      return "其它";
    },


  }
}
</script>
<style>
.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  /* width: 100%; */
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
<style lang="scss" scoped>
/deep/ .el-table__body tr.current-row>td {
  background-color: #409EFF;
  color:#fff;
}

</style>
